'use client';

import { createStore } from 'zustand';
import type {
  ParsedCartFlattenedGroupsDTO,
  UserCheckoutDetails,
} from 'ui/types/cartTypes';
import { CART_LOCAL_STORAGE_NAME } from '@/lib/constants';

export interface CartStore {
  isLoadingCart: boolean;
  cart: ParsedCartFlattenedGroupsDTO | null;
  userCheckoutDetails: UserCheckoutDetails | null;
  isCartOpen: boolean;
  setIsLoadingCart: (value: boolean) => void;
  setUserCheckoutDetails: (newUserCheckoutDetails: UserCheckoutDetails) => void;
  setCart: (newCart: ParsedCartFlattenedGroupsDTO) => void;
  clearCart: () => void;
  setIsCartOpen: (isOpen: boolean) => void;
}

// Check if window is defined (client-side) or not (server-side)
const isClient = typeof window !== 'undefined';

// Store initializer
export const createCartStore = (preloadedState?: Partial<CartStore>) =>
  createStore<CartStore>((set) => ({
    isLoadingCart: false,
    cart: null,
    userCheckoutDetails: null,
    isCartOpen: false,
    setIsLoadingCart: (value) => {
      set(() => ({ isLoadingCart: value }));
    },
    setCart: (newCart) => {
      set(() => ({ cart: newCart }));
      if (isClient && newCart && newCart.id) {
        localStorage.setItem(CART_LOCAL_STORAGE_NAME, newCart.id);
      }
    },
    setUserCheckoutDetails: (newUserCheckoutDetails) => {
      set(() => ({ userCheckoutDetails: newUserCheckoutDetails }));
    },
    setIsCartOpen: (isOpen: boolean) => {
      set(() => ({ isCartOpen: isOpen }));
    },
    clearCart: () => {
      set(() => ({ cart: null }));
      if (isClient) {
        localStorage.removeItem(CART_LOCAL_STORAGE_NAME);
      }
    },
    ...preloadedState,
  }));
